// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 714 ? "fec483df" : chunkId) + "." + {"153":"bbbaf531880b6919","161":"3960284b83dba9ed","611":"48a2d59f99cef77c","714":"3652308348a3c503"}[chunkId] + ".js";
};